import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-header-unauth',
  templateUrl: './header-unauth.component.html',
  styleUrls: ['./header.component.scss'],
})
export class AppHeaderUnAuthComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
